import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IMultiSelectOption } from 'angular-2-dropdown-multiselect';
import * as moment from "moment";
import { LocalStorage } from 'ngx-store';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Url } from '../model/users.model';
import { Payment } from '../model/invoices.model';

@Injectable()
export class InvoicesService {

    @LocalStorage() url: Url;

  	private headers = new Headers({ 'Content-Type': 'application/json' });
    // Http Headers
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    }

    constructor(public http:HttpClient) { 
    }


    getInvoiceSelectData(): Observable<IMultiSelectOption[]> { 
        return this.http.get<IMultiSelectOption[]>(this.url.rest  + '/tms/getInvoiceSelectData', this.httpOptions)
        .pipe(
            retry(1),
            catchError(this.handleError)
        )

    }

    getInvoiceJobs(): Observable<IMultiSelectOption[]> { 
        return this.http.get<IMultiSelectOption[]>(this.url.rest  + '/tms/getInvoiceJobs', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            ) 
    
    }


    getInvoiceJobDetails(id: string): Observable<any[]> {
        return this.http.get<any[]>(this.url.rest  + '/tms/getInvoiceJobDetails/' + id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }


    getInvoiceData(): Observable<any> {
        return this.http.get<any>(this.url.rest  + '/tms/getInvoiceData', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getPendingInvoices(): Observable<any> {
        return this.http.get<any>(this.url.rest  + '/tms/getPendingInvoices', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getSentInvoices(): Observable<any> {
        return this.http.get<any>(this.url.rest  + '/tms/getSentInvoices', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }


    getPartialInvoices(): Observable<any> {
        return this.http.get<any>(this.url.rest  + '/tms/getPartialInvoices', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getPaidInvoices(): Observable<any> {
        return this.http.get<any>(this.url.rest  + '/tms/getPaidInvoices', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getOverdueInvoices(): Observable<any> {
        return this.http.get<any>(this.url.rest  + '/tms/getOverdueInvoices', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getArchivedInvoices(): Observable<any> {
        return this.http.get<any>(this.url.rest  + '/tms/getArchivedInvoices', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }


    getInvoiceDetails(id: number): Observable<any[]> {
        return this.http.get<any[]>(this.url.rest  + '/tms/getInvoiceDetails/' + id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }


    
    getInvoiceEditDetails(id: number): Observable<any[]> {
        return this.http.get<any[]>(this.url.rest  + '/tms/getInvoiceEditDetails/' + id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    sendInvoice(email: any): Observable<any> {
        return this.http.post<any>(this.url.rest  + '/tms/sendInvoice', email, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }
    
    markPaid(invoice: any): Observable<{ invoice_id: number, payment_id: number }> {
        return this.http.post<any>(this.url.rest  + '/tms/markInvoiceAsPaid', invoice, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    // invoice text notes
    getNotes(id: number): Observable<any[]> {
        return this.http.get<any[]>(this.url.rest  + '/tms/getInvoiceTextNotes/' + id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    createNote(note: any): Observable<any> {
        return this.http.post<any>(this.url.rest  + '/tms/createInvoiceTextNote', note, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    updateNote(note: any): Observable<any> {
        return this.http.post<any>(this.url.rest  + '/tms/updateInvoiceTextNote', note, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    deleteNote(id: number): Observable<any[]> {
        return this.http.delete<any[]>(this.url.rest  + '/tms/deleteInvoiceTextNote/' + id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getManagePayments(invoiceId: number): Observable<Payment[]> { 
        return this.http.get<Payment[]>(this.url.rest  + '/tms/getInvoicePayments/' + invoiceId, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    createPayment(payment:any): Observable<any> {
        return this.http.post<any>(this.url.rest  + '/tms/addInvoicePayment', payment, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    updatePayment(payment:any): Observable<{ data: { id: number } }> {
        console.log('service',payment)
        return this.http.post<any>(this.url.rest  + '/tms/updateInvoicePayment', payment, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    deletePayment(invoice_id:number,id: number, user_id: number): Observable<any> {
        return this.http.delete<any>(this.url.rest  + '/tms/deleteInvoicePayment/' + invoice_id +"/" + id +"/" + user_id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    generateInvoiceDoc(invoice){
        return this.http.post<any>(this.url.rest  + '/tms/createInvoice', invoice, this.httpOptions)
        .pipe(
            retry(1),
            catchError(this.handleError)
        )
    }


    // end invoice text notes
    
    cancelInvoice(data: any): Observable<any> {
        return this.http.post<any>(this.url.rest  + '/tms/cancelInvoice', data, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    createAttachments(invoice_id:number, data: any): Observable<any> {
        return this.http.post<any>(this.url.rest  + '/tms/createAttachments/' + invoice_id, data, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    
    truncateEmailAttachments(invoice_id:number): Observable<any> {
        return this.http.post<any>(this.url.rest  + '/tms/truncateEmailAttachments/' + invoice_id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getInvoices(statusFilter = '', dateFilter = '', start = '', end = ''): Observable<any[]> { 
        var param = '';
        if (statusFilter) {
            param = '/' + statusFilter;
            if (dateFilter) {
                param = param + '/' + dateFilter;
                if (dateFilter == 'range') {
                    if (moment(end).isSameOrAfter(moment(start))) {
                        param = param + '/' + start + '/' + end; 
                    }
                } 
            }

        }
        return this.http.get<any[]>(this.url.rest  + '/tms/getInvoices' + param, this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        ) 
      }

    getCreditNoteAllocationList():Observable<any>{
        return this.http.get<any[]>(this.url.rest + '/tms/getCreditNoteAllocationList', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            ) 
    }

    // Error handling
    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }

}